import { create } from 'zustand';
import { SummaryWidgetCounts, SummaryWidgetKey } from '../definitions/inventorySummary';

interface InventorySummaryStore {
  counts: SummaryWidgetCounts;
  loadingKeys: Partial<Record<SummaryWidgetKey, boolean>>;
  errorKeys: Partial<Record<SummaryWidgetKey, boolean>>;

  setCount: (key: SummaryWidgetKey, count: number) => void;
  setLoading: (key: SummaryWidgetKey, loading: boolean) => void;
  setError: (key: SummaryWidgetKey, hasError: boolean) => void;
}

const useInventorySummaryStore = create<InventorySummaryStore>()((set) => ({
  counts: {},
  loadingKeys: {},
  errorKeys: {},

  setCount: (key, count) => set((state) => ({ counts: { ...state.counts, [key]: count } })),
  setLoading: (key, loading) => set((state) => ({ loadingKeys: { ...state.loadingKeys, [key]: loading } })),
  setError: (key, hasError) => set((state) => ({ errorKeys: { ...state.errorKeys, [key]: hasError } })),
}));

export default useInventorySummaryStore;
